<!--
Copyright 2025 Google LLC. This software is provided as-is, without warranty
or representation for any use or purpose. Your use of it is subject to your
agreement with Google.
-->
<div class="main">
    <header class="header" #header>
        <div class="guidelines-header">
            <img src="../../assets/asco-logo.png" alt="ASCO Logo" class="asco-logo" (click)="refreshChatMsgs()">
        </div>
    </header>
    <main class="main-content">
        <div class="scrollable" #parentContainer>
            <div [ngClass]="{'content' : chatMsgs.length==0}" >
                <div class="container">
                    <div class="row guidelines" *ngIf="chatMsgs.length==0">

                        <div class="d-flex flex-column justify-content-center align-items-center guidelines-title">
                            <div
                                class="d-flex flex-column justify-content-center align-items-center guidelines-message">
                                <span class="guidelines-logo-background">
                                    <img src="../../assets/guidelines-logo.svg" alt="guidelines-logo"
                                        class="guidelines-logo">
                                </span>
                                <span class="welcome-message">
                                    <span>Welcome to ASCO<span class="registered-symbol">®</span> Guidelines
                                        Assistant</span>
                                </span>
                            </div>
                            <div *ngIf="starter_questions_not_found" class="starter-questions-error">
                                <div class="error-message">
                                    <img src="../../assets/error.png" alt="asco-thumbnail" class="error-icon">
                                    <span class="error-title">Starter questions are currently unavailable</span>
                                    <span class="error-subtitle">We're having trouble loading the starter questions. You
                                        can still ask your own questions below.</span>
                                </div>
                            </div>
                        </div>
                        <div class="starter-questions" *ngIf="starter_questions.length>0 && !starterQuestionsLoader">
                            <span class="question-cards" *ngFor="let ques of starter_questions">
                                <span class="question-card" (click)="addQuestionToChat(ques)">
                                    <span>{{ques}}</span>
                                    <button class="ask-btn">
                                        <img src="../../assets/lightbulb.svg" alt="ASK" class="ask-logo">
                                    </button>
                                </span>
                            </span>
                        </div>
                        <div class="starter-questions" *ngIf="starterQuestionsLoader">
                            <div class="question-cards">
                                <span class="question-card" *ngFor="let ind of sampleList">
                                    <div class="skeleton">
                                        <div class="line"></div>
                                        <div class="line"></div>
                                        <div class="line"></div>
                                        <div class="line"></div>
                                        <div class="line-short"></div>
                                    </div>
                                    <div class="avatar"></div>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="loading-overlay" *ngIf="isPreviewPanelLoading && isMobileView">
                        <div class="spinner"></div>
                    </div>
                    <div class="row chat-interface" *ngIf="chatMsgs.length>0">
                        <div
                            [ngClass]="((citationContent && !isMobileView && isPreviewVisible) || (isPreviewPanelLoading && !isMobileView)) ? 'col-8' : 'col-12'">
                            <div *ngIf="chatMsgs.length>0">
                                <ul id="messages">
                                    <li *ngFor="let msg of chatMsgs ; let ind = index">
                                        <app-conversation [userQuestion]="msg?.userQuestion"
                                            (selectedCitation)="showCitation($event)"
                                            (fuqQuestionForFollowup)="followUp($event)"
                                            (isPreviousCitationHighlighted)="clearCitations($event)"
                                            ></app-conversation>
                                    </li>
                                </ul>
                                <div #scrollToHere>
                                </div>
                            </div>
                        </div>
                        <div class="col-4" *ngIf="!isMobileView">
                            <ng-container>
                                <div class="previewPanelLoader" *ngIf="isPreviewPanelLoading">
                                    <div class="loader"></div>
                                </div>
                                <app-preview-citation *ngIf="isPreviewVisible" [selectedCitation]="citationContent"
                                    [previewPanelError]="isPreviewPanelError" [previewPanelHeight]="previewPanelHeight"
                                    (closePreviewSection)="closePreviewSection($event)">
                                </app-preview-citation>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <footer class="footer" #footer>
        <div class="container">
            <div class="row justify-content-center g-3">
                <form [formGroup]="followUpForm" class="followUpForm">
                    <div [ngClass]="{'empty-query-entered' : isEmptyQueryEntered}" class='followupWrapper'
                        [ngClass]="(followUpQuery.value.length>30) ? 'followUp-query-boxy' : 'followUp-query'">
                        <textarea type="text" #followUpQuery class="followUp-input"
                            placeholder="Ask ASCO Guidelines Assistant" formControlName="userInput" required
                            (keydown.enter)="followUp(followUpQuery.value , $event)" maxlength="2000"
                            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5" autofocus>
                        </textarea>

                        <img class="followUp ml-2" src="../../assets/send-icon.png" *ngIf="followUpQuery.value.length>0"
                            (click)="followUp(followUpQuery.value , $event)" alt="followUp query">
                    </div>
                    <p class="alert alert-danger" *ngIf="followUpQuery.value.length>=2000">
                        Please make your question less than 2000 characters.
                    </p>
                    <div class="charlimit" *ngIf="followUpQuery.value.length>=1900">
                        {{2000 - followUpQuery.value.length}} Characters Left</div>

                    <div class="disclaimer" *ngIf="chatMsgs.length>0">
                        <span>
                            This resource may make mistakes or be out of date. Not medical advice. Use professional
                            judgment. Do not identify patients.
                            <a href="https://www.asco.org/about-asco/legal/guidelines-assistant-disclaimer"
                                target="_blank" rel="noopener noreferrer">Read more here.</a>
                        </span>
                    </div>
                </form>
                  <div class="landing-page-disclaimer" *ngIf="chatMsgs.length==0">
                    <span>
                        This informational resource is derived from clinical practice guidelines as published by the
                        American Society of Clinical Oncology®. Guidelines Assistant does not recommend a course of
                        treatment, does not account for variation among patients, and does not substitute for the
                        independent professional judgment of a health care professional. This is not a HIPAA protected
                        environment so do not use identifiable patient information.
                        <a href="https://www.asco.org/about-asco/legal/guidelines-assistant-disclaimer" target="_blank"
                            rel="noopener noreferrer">Read more here.</a>
                    </span>
                </div>
            </div>
        </div>
    </footer>
</div>
